import { MagicIcon } from "shared/theme/icons/MagicIcon";
import CircularProgress from "@mui/material/CircularProgress";
import { StyledButton } from "./styled";
import { LocaleCode } from "shared/types/languages";

type AutoTranslateProps = {
    langId: LocaleCode;
    isLoading: boolean;
    handleAutoTranslate: (value: LocaleCode) => void;
};

export const AutoTranslateButton = ({langId, isLoading, handleAutoTranslate}: AutoTranslateProps) => (
    <StyledButton
        color="secondary"
        title="Auto Translate"
        variant="outlined"
        size="small"
        onClick={() => handleAutoTranslate(langId)}
        icon={isLoading ? <CircularProgress size={14} color="inherit"/> : <MagicIcon/>}
    />
)